import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

export const addColorantPackages = (colorantPackages) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_STOCK_ADD_COLORANT_PACKAGES,
        params: {
            colorantPackages: colorantPackages
        }
    },
    method: handlers.STOCK_ADD_COLORANT_PACKAGES,
    tabId: 0
});

export const addColorantPackagesOrders = (colorantPackages) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_STOCK_ADD_COLORANT_PACKAGES_ORDERS,
        params: {
            colorantPackages: colorantPackages
        }
    },
    method: handlers.STOCK_ADD_COLORANT_PACKAGES_ORDER,
    tabId: 0
});

export const calculatePredictions = () => ({
    type: actionTypes.STOCK_CALCULATE_PREDICTION
});

export const getColorantPackages = (colorant = "") => {
    let payload = {
        type: methods.METHOD_STOCK_GET_COLORANT_PACKAGES
    };

    if (colorant !== "") {
        payload.params = {
            colorant: colorant
        };
    }

    return {
        type: actionTypes.SERVER_REQUEST,
        payload: payload,
        method: handlers.STOCK_GET_COLORANT_PACKAGES,
        tabId: 0
    };
};

export const removeColorantPackage = (colorantPackageStock, saveResult, showFlashMessage) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_STOCK_REMOVE_COLORANT_PACKAGE,
        params: {
            colorant: colorantPackageStock.colorant,
            package: colorantPackageStock.package
        }
    },
    method: handlers.STOCK_REMOVE_COLORANT_PACKAGE,
    tabId: 0,
    next: {
        saveResult: saveResult,
        showFlashMessage: showFlashMessage
    }
});

export const resetAllColorantPackages = () => ({
    type: actionTypes.STOCK_RESET_COLORANT_PACKAGES
});

export const resetCart = () => ({
    type: actionTypes.STOCK_RESET_CART
});

export const saveCart = (cart) => ({
    type: actionTypes.STOCK_SAVE_CART,
    payload: cart
});

export const setPredictionForColorantPackageStock = (history) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_STOCK_SET_PREDICTION_FOR_COLORANT_PACKAGE,
        params: {
            history: history
        }
    },
    method: handlers.STOCK_SET_PREDICTION_FOR_COLORANT_PACKAGES,
    tabId: 0
});
